import React from "react";
import { RefreshCw } from "lucide-react";

const ReportsHeader = ({ theme, isRTL, text, language, onRefresh, refreshing }) => {
  const isDark = theme === "dark";

  return (
    <div
      style={{
        background: isDark ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        padding: "28px 32px",
        borderRadius: 24,
        border: isDark ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(0,0,0,0.05)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        boxShadow: isDark ? "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)" : "0 8px 32px rgba(0,0,0,0.1)",
        marginBottom: 22,
        marginTop: -36,
        direction: isRTL ? "rtl" : "ltr",
        display: "flex",
        flexWrap: "wrap",
        gap: 20,
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div>
        <h1 style={{ margin: 0, fontSize: 28, fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b", letterSpacing: "-0.5px" }}>
          {text[language].title}
        </h1>
        <p style={{ margin: "10px 0 0 0", fontSize: 14.5, fontWeight: 500, color: isDark ? "#cbd5e1" : "#64748b" }}>
          {text[language].subtitle}
        </p>
      </div>

      <button
        type="button"
        onClick={onRefresh}
        aria-label={text[language].refresh}
        style={{
          display: "flex", alignItems: "center", justifyContent: "center", width: 40, height: 40, borderRadius: 12,
          border: "none", background: "linear-gradient(135deg, #3b82f6, #2563eb)", color: "#fff", cursor: "pointer",
          boxShadow: "0 4px 14px rgba(59,130,246,0.35)", flexShrink: 0,
        }}
      >
        <RefreshCw size={16} style={{ animation: refreshing ? "spin 1s linear infinite" : "none" }} />
      </button>
    </div>
  );
};

export default ReportsHeader;
